// GA4 Measurement IDs are public (they appear in every page). Not a secret.
export const GA_MEASUREMENT_ID = "G-CGX012B68V";
